import service from "@/libs/service";

export const namespaced = true;

export const actions = {
    keys({ commit }, resource) {
        return new Promise((resolve, reject) => {
            service.request("/notifications/keys").then(content => {
                resolve(content.credentials);
            }).catch(err => {
                reject(err);
            });
        });
    },
    sendEmail({ commit }, email) {
        return new Promise((resolve, reject) => {
            if (!email.service.template) {
                email.service.template = "general";
            }    
            service.request("/notifications/email", email).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    get({ commit }, resource) {
        return new Promise((resolve, reject) => {
            service.request("/notifications").then(content => {
                resolve(content.notifications);
            }).catch(err => {
                reject(err);
            });
        });
    },
    update({ commit }, readed) {
        return new Promise((resolve, reject) => {
            service.request("/notifications/update", {
                readed
            }).then(() => {
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    }
};



export default {
    // state,
    // mutations,
    // getters,
    actions
};
